class CustomTabbedFaq extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('.ctf-tab');
    this.faqItems = this.querySelectorAll('.ctf-faq-item');
    this.activeTitle = this.querySelector('.ctf-active-title');

    this.bindEvents();
    this.init();
  }

  bindEvents() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => this.handleTabClick(e));
    });
  }

  init() {
    // Select the first tab automatically if none is selected
    const activeTab = this.querySelector('.ctf-tab.is-active') || this.tabs[0];
    if (activeTab) {
      this.activateCategory(activeTab);
    }
  }

  handleTabClick(event) {
    const clickedTab = event.currentTarget;
    if (clickedTab.classList.contains('is-active')) return;
    this.activateCategory(clickedTab);
  }

  activateCategory(tab) {
    const categoryName = tab.dataset.category;
    
    // Update Active Tab Styling
    this.tabs.forEach(t => t.classList.remove('is-active'));
    tab.classList.add('is-active');

    // Update Title
    if (this.activeTitle) {
      this.activeTitle.textContent = categoryName;
    }

    // Filter FAQ Items
    this.faqItems.forEach(item => {
      if (item.dataset.category === categoryName) {
        item.classList.add('is-visible');
      } else {
        item.classList.remove('is-visible');
        item.removeAttribute('open'); // Close accordion when hiding
      }
    });
  }
}

customElements.define('custom-tabbed-faq', CustomTabbedFaq);
